import * as PIXI from "pixi.js";
import Layers from "../../../../../src/layers/Layers";
import Angle from "../../../../../src/entities/Angle/Angle";
import { Coord } from "../../../../../src/types/Interface";


export default class SupplAngleLine extends PIXI.Container {
  private Layers = Layers.getInstance();
  private supplAngles: SupplAngle[] = [];
  constructor(coord: Coord, tags: string[], colors: number[]) {
    super();
    Object.assign(this, coord);
    this.addAngles(colors, tags);
    this.addSymbols();
    this.addToLayer();
  }
  getSupplAngle = () => this.supplAngles;
  addToLayer = () => this.Layers.Info.addChild(this);
  setVisible = (v: boolean) => {
    this.visible = v;
    this.supplAngles.forEach(angle => angle.visible = v);
  };
  addAngles(colors: number[], tags: string[]) {
    this.supplAngles = [-70, 0, 100, 100].map((x, xI) => {
      const sAngle = new SupplAngle({ x, y: 0 }, tags[xI], colors[xI % 2]);
      this.addChild(sAngle);
      return sAngle;
    });
  }
  addSymbols() {
    const xs = [-30, 50];
    const symbols = ["+", "="].map((t, tI) => {
      const text = new PIXI.Text({ text: t });
      text.style.fontSize = 35;
      text.x = xs[tI];
      text.anchor.set(.5, .8);
      this.addChild(text);
      return text;
    })
  }
}


export class SupplAngle extends Angle {
  coord: Coord
  constructor(coord: Coord, tag: string, color: number) {
    super(tag, { color, textColor: 0x000000 }, -100, true);
    this.coord = coord;
    this.scale.set(.5);
  }
}